import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import IosShareIcon from "@mui/icons-material/IosShare";
import {useMenuTranslation} from "../menu/menuTranslationContext";
import {TOUCH_TARGET} from "./touchTarget";

const TITLE_ID = 'ios-install-dialog-title';

/**
 * Tells iPhone/iPad users how to add DAMS to the home screen; iOS has no install API (DE-1707).
 *
 * @param {Object} props
 * @param {boolean} props.open
 * @param {function(): void} props.onClose
 */
export const IosInstallDialog = ({open, onClose}) => {
    const t = useMenuTranslation();

    return (
        <Dialog open={open} onClose={onClose} aria-labelledby={TITLE_ID}>
            <DialogTitle id={TITLE_ID}>{t('installAppIosTitle', 'Installer DAMS som app')}</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    <IosShareIcon fontSize="small" aria-hidden="true" sx={{verticalAlign: 'text-bottom', marginRight: 1}}/>
                    {t('installAppIosInstructions', 'Trykk på Del-knappen, og velg «Legg til på Hjem-skjerm».')}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} sx={TOUCH_TARGET}>{t('installAppClose', 'Lukk')}</Button>
            </DialogActions>
        </Dialog>
    );
};
